import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const useWishlistStore = create(
  persist(
    (set, get) => ({
      items: [], // array of product IDs or product objects

      // Toggle wishlist item
      toggle: (productId) => {
        set((state) => {
          const exists = state.items.some((id) => id === productId)
          if (exists) {
            return { items: state.items.filter((id) => id !== productId) }
          } else {
            return { items: [...state.items, productId] }
          }
        })
      },

      // Add product to wishlist
      add: (productId) => {
        set((state) => {
          if (state.items.includes(productId)) return state
          return { items: [...state.items, productId] }
        })
      },

      // Remove product from wishlist
      remove: (productId) => {
        set((state) => ({
          items: state.items.filter((id) => id !== productId),
        }))
      },

      // Check if product is wishlisted
      isWishlisted: (productId) => {
        return get().items.includes(productId)
      },

      // Clear wishlist
      clear: () => set({ items: [] }),

      // Get count
      getCount: () => get().items.length,
    }),
    {
      name: 'Rayoptics-wishlist',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

export { useWishlistStore }
export default useWishlistStore
